import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { RealtimeActions } from '../+state/realtime.actions';
import { BusLocationMap, StopCode } from '../model/realtime.models';

export const REALTIME_STATE_KEY = 'realtime';

export interface RealtimeState {
    locations: BusLocationMap;
    selectedLocation: any;
    shapes: any[];
    stopCodes: StopCode;
}
export const REALTIME_INITIAL_STATE: RealtimeState = {
    locations: {},
    selectedLocation: null,
    shapes: [],
    stopCodes: null
};

export function realtimeReducer(
    lastState: RealtimeState = REALTIME_INITIAL_STATE,
    action: RidangoReduxAction
): RealtimeState {
    switch (action.type) {
        case RealtimeActions.CLEAR_EXPIRED_LOCATIONS: {
            const newLocations = { ...lastState.locations };
            const now = new Date();
            for (const deviceId in newLocations) {
                if (newLocations[deviceId].expiring_time < now) {
                    delete newLocations[deviceId];
                }
            }
            return tassign(lastState, { locations: newLocations });
        }
        case RealtimeActions.SET_LOCATIONS:
            // tassign() is merging old state and new payload together
            return { ...lastState, locations: action.payload };
        case RealtimeActions.SET_SELECTED_LOCATION:
            return tassign(lastState, { selectedLocation: action.payload });
        case RealtimeActions.SET_SHAPES:
            return tassign(lastState, { shapes: action.payload });
        case RealtimeActions.SET_REALTIME_SCHEDULE:
            return tassign(lastState, { stopCodes: action.payload });
        case RealtimeActions.CLEAR_REALTIME_SCHEDULE:
            return tassign(lastState, { stopCodes: null });
    }

    return lastState;
}

export interface RealtimePartialStoreState {
    [REALTIME_STATE_KEY]: RealtimeState;
}
